import React from 'react';
import { ModalHeaderBase, SvgIcon } from 'seduo-ui';
const ModalHeader = ({ toggle, children, close, tag, className }) => {
    let closeButton = close;
    if (!close && toggle) {
        closeButton = (<button type="button" onClick={toggle} className="close" aria-label="Close">
                <span aria-hidden="true">
                    <SvgIcon kind="Close" size={20}/>
                </span>
            </button>);
    }
    return (<ModalHeaderBase toggle={toggle} close={closeButton} tag={tag} className={className}>
            {children}
        </ModalHeaderBase>);
};
ModalHeader.defaultProps = {
    toggle: null,
    close: null,
    className: '',
    tag: 'h5',
};
export default ModalHeader;
